var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-container"},[_c('v-chart',{attrs:{"options":_vm.barOptions,"autoresize":"","theme":"light"}}),_c('div',[_vm._v(_vm._s(_vm.$t('Home.table1Desc')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }